/* eslint-disable no-underscore-dangle */
import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

const { Types, Creators } = createActions(
  {
    fetchRequest: ["params"],
    fetchSuccess: ["data"],
    fetchFailure: ["error"],
    reset: [],
  },
  { prefix: "DEPOIMENTOS_" }
);

export const DepoimentosTypes = Types;
export default Creators;

const INITIAL_STATE = {
  data: [],
  loading: true,
  error: null,
};

// fetch
const _fetchRequest = (state) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });
const _fetchSuccess = (state, action) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });
const _fetchFailure = (state, action) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const _reset = () => INITIAL_STATE;

export const depoimentos = createReducer(INITIAL_STATE, {
  [Types.FETCH_REQUEST]: _fetchRequest,
  [Types.FETCH_SUCCESS]: _fetchSuccess,
  [Types.FETCH_FAILURE]: _fetchFailure,
  [Types.RESET]: _reset,
});
